
import Spinner from '../components/Spinner';
import {playMediaList} from '../player/hooks';
import {getAlbumSongList} from '../api';

import {Album, ComputedPage, Song} from '../../types';

import {reactive, watch, defineComponent, PropType, ref} from 'vue';
import {TableColumn} from '../components/types';

export default defineComponent({
  name: 'AlbumView',

  props: {query: Object as PropType<Album>},

  setup(props) {
    const songList = reactive<Song[]>([]);
    const album = reactive<Album>({mid: '', name: '', cover: '', company: ''});
    const page = {current: 1, size: 30, total: 1} as ComputedPage;

    const columns: TableColumn[] = [
      {type: 'index', width: '100px'},
      {title: '歌曲', property: 'title', flex: true},
      {title: '歌手', property: 'singer'},
      {title: '时长', property: 'duration', width: '100px'},
      {title: '大小', property: 'size', width: '100px'}
    ];

    const multiple = ref(false);

    watch(() => props.query, newQuery => {
      if (newQuery && album.mid !== newQuery.mid) {
        Spinner.open();

        getAlbumSongList(page, newQuery).then(data => {
          // 重设分页信息
          Object.assign(page, data.page);
          // 更新专辑信息
          data.album && Object.assign(album, data.album);
          // 添加歌曲数据
          songList.splice(0, songList.length, ...data.list);

        }).finally(Spinner.close);
      }

    }, {immediate: true});

    return {
      songList, page, album, columns, multiple,

      playMediaList,

      /** 加载歌曲数据到表格视图中 */
      loadDataList() {
        // 若还有数据, 则发起网络请求加载歌曲数据列表
        if (page.current >= 1 && page.current < page.pageCount) {
          ++page.current;
          Spinner.open();

          getAlbumSongList(page, album).then(data => {
            // 重设置分页信息
            data.page && Object.assign(page, data.page);
            // 添加歌曲
            songList.push(...data.list);

          }).catch(() => --page.current).finally(Spinner.close);
        }
      }
    };

  }

});
